import React from 'react';
import { Formik } from 'formik';
import { login_schema, login_validation_schema } from 'validation_schema/login_validation_schema';
import { Button } from 'components/ui/button';
import InputField from 'components/InputField';
import LoginFunctional from './index.function';
import { logo_image } from 'asset/images';
import Text from 'components/Text';
import { fontSizes } from 'appconstants';
import ErrorText from 'components/ErrorText';
import { cross_icon } from 'asset/icons';

const Login = () => {
  const { handleLogin, auth_loading, passwordRef } = LoginFunctional();

  return (
    <div className='flex min-h-screen w-full items-center justify-center bg-primary/10'>
      <div className='w-full max-w-xl rounded-2xl bg-white shadow-lg p-8 mx-4'>
        <div className='w-full flex flex-col justify-center mb-6'>
          <img src={logo_image} alt='Dole Logo' className='mx-auto w-[160px] h-[90px] mb-6' />
          <Text text='Dole Product Audit App' className='text-center font-semibold' size={fontSizes.h20} />
        </div>

        <Text text='Login' className='font-semibold' size={fontSizes.h26} />
        <Text text='Enter your credentials to access your account' className='text-muted-foreground' size={fontSizes.h14} />

        <Formik
          initialValues={login_schema}
          validationSchema={login_validation_schema}
          onSubmit={(values: LoginSchema) => handleLogin(values)}
          validateOnBlur={false}
          validateOnChange={false}
        >
          {({ values, setFieldValue, setFieldError, handleSubmit, errors }) => (
            <div className='flex flex-col gap-6 mt-4'>
              <div>
                <InputField
                  label='Email'
                  type='email'
                  placeholder='you@example.com'
                  value={values?.email}
                  onChange={(text) => {
                    setFieldValue('email', text);
                    setFieldError('email', '');
                  }}
                  rightIcon={cross_icon}
                  onPressEnter={() => passwordRef?.current?.focus()}
                  onPressIcon={() => setFieldValue('email', "")}
                />
                <ErrorText text={errors?.email} />
              </div>

              <div>
                <InputField
                  label='Password'
                  type='password'
                  placeholder='Enter your password'
                  value={values?.password}
                  onChange={(text) => {
                    setFieldValue('password', text);
                    setFieldError('password', '');
                  }}
                  props={{
                    ref: passwordRef,
                  }}
                  onPressEnter={handleSubmit}
                />
                <ErrorText text={errors?.password} />
              </div>

              <Button onClick={() => handleSubmit()} className='w-full mt-2' loading={auth_loading}>
                Login
              </Button>
            </div>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default Login;
